import { OrderViewModel } from '@ail/orders-api';
import { CsvTableSection } from '../../common/Modals/CsvModal/Table/CsvTable';

export const WorkItemsCsvStructure = (workItem: OrderViewModel | undefined): CsvTableSection[] => [
    {
      name: 'Customer',
      icon: 'icon-customers',
      columnCount: 2,
      rows: [
        {
          row: {
            1: {value: 'Company address', copy: false},
            2: {value: workItem?.data.address, copy: true}
          }
        },
        {
          row: {
            1: {value: 'User', copy: false},
            2: {value: workItem?.userDisplayName, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Email', copy: false},
            2: {value: workItem?.data.email, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Phone', copy: false},
            2: {value: workItem?.data.phone, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Message', copy: false},
            2: {value: workItem?.data.message, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Subject', copy: false},
            2: {value: workItem?.data.subject, copy: true}
          }
        }
      ]
    },
    {
      name: 'Vehicle',
      icon: 'icon-car',
      columnCount: 2,
      rows: [
        {
          row: {
            1: {value: 'Plate', copy: false},
            2: {value: workItem?.data.plate, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Brand', copy: false},
            2: {value: workItem?.data.brand, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Model', copy: false},
            2: {value: workItem?.data.model, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Contract reference', copy: false},
            2: {value: workItem?.data.contractReference, copy: true}
          }
        }
      ]
    },
    {
      name: 'Details',
      icon: 'icon-info',
      columnCount: 2,
      rows: [
        {
          row: {
            1: {value: 'Cost range', copy: false},
            2: {value: workItem?.data.costRange, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Type of work', copy: false},
            2: {value: workItem?.data.typeOfWork, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Activities', copy: false},
            2: {value: workItem?.data.activities, copy: true}
          }
        },
        {
          row: {
            1: {value: 'Date of submission', copy: false},
            2: {value: workItem?.created, copy: true}
          }
        }
      ]
    }
  ]